import FarmLocations from '@app/components/apps/FarmLocations/FarmLocationForm';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { Col, Row, Button as BaseButton } from 'antd';
import { useEffect, useState } from 'react';

const routes = [
  { path: '/all-farms', breadcrumbName: 'My Establishments / Farms' },
  { path: '/register-farm', breadcrumbName: 'Register Establishment / Farm' },
];

const RegisterFarm = () => {
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Register Establishment / Farm');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <FarmLocations
          editable={true}
          pageTitle={'Register Establishment / Farm'}
          type={'create'}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default RegisterFarm;
